import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from '../landing/main/theme/theme';
import { QuizApp } from './quizApp';
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container #root not found');
}
const root = ReactDOM.createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(QuizApp, {})] }) }));
